export const LICENSE_DATE_ORDER_MESSAGE = 'Expiration date must be on or after the issue date.';
//# sourceMappingURL=license-date-order-message.js.map